
import {
    Handler as GraphQLHandler,
    HandlerContent,
    HandlerForward,
    HandlerRedirect,
    Slot,
    Entity as GraphQLEntity,
    Intent as GraphQLIntent
} from "generated/graphql";
import { Entity, Handler, Intent } from "stentor-models";

/**
 * Converts the GraphQL style Handler to the stentor-models pattern.
 *
 * @param graphql
 */
export function convertHandler(handler: Handler): Omit<GraphQLHandler, "validation" | "permissions"> {

    // TODO: Add context back in
    const { content, forward, redirect, slots: handlerSlots, ...remaining } = handler;

    const contentArray: HandlerContent[] = [];
    const contentKeys = Object.keys(content || {});
    for (const key of contentKeys) {
        const responses = content[key];
        contentArray.push({
            "key": key,
            // @ts-ignore close enough - it doesn't like the display type differences
            handlerResponse: responses
        });
    }

    const forwardArray: HandlerForward[] = [];
    const forwardKeys = Object.keys(forward || {});
    for (const key of forwardKeys) {
        const paths = forward[key];
        forwardArray.push({
            "key": key,
            paths
        });
    }

    const redirectArray: HandlerRedirect[] = [];
    const redirectKeys = Object.keys(redirect || {});
    for (const key of redirectKeys) {
        const paths = redirect[key];
        redirectArray.push({
            "key": key,
            paths
        });
    }

    const slots: Omit<Slot, "_id">[] = [];
    (handlerSlots || []).forEach((slot) => {
        // @ts-ignore close enough
        slots.push({
            ...slot
        });
    });


    const graphQLHandler: Omit<GraphQLHandler, "validation" | "permissions"> = {
        ...remaining,
        // @ts-ignore close enough
        slots,
        forward: forwardArray,
        redirect: redirectArray,
        content: contentArray
    }

    return graphQLHandler;
}

export function convertEntity(entity: Entity): Omit<GraphQLEntity, "validation" | "_id" | "intents"> {

    const { ...remaining } = entity;

    // @ts-ignore close enough
    return { ...remaining };
}

export function convertIntent(intent: Intent): Omit<GraphQLIntent, "validation" | "_id" | "utteranceSuggestions"> {
    // @ts-ignore content can exist
    const { content, ...remaining } = intent;
    // @ts-ignore close enough
    return { ...remaining };
}